<app-card-scroller *ngIf="details !== undefined" [header]= "((details.title | translateLang | async) ?? '')">
    <div class="section-desc desktop-hide">
        {{ details.description | translateLang | async }}
    </div>
    <div class="content-wrapper">
        <div class="details">
            <div class="section desktop-show">
                {{ details.description | translateLang | async }}
            </div>
            <div class="section fixed-grid">
                <div class="item-container">
                    <div class="label">{{ 'iaa.scientificArchiveDocument.scientificArchiveDocumentDetails.documentLongId' |translate}}</div>
                    <div class="value">{{ details.documentLongId }}</div>
                </div>
                <div class="item-container">
                    <div class="label">{{ 'iaa.scientificArchiveDocument.scientificArchiveDocumentDetails.type' |translate}}</div>
                    <div class="value">{{ details.type | translateLang | async }}</div>
                </div>
                <div class="item-container">
                    <div class="label">{{ 'iaa.scientificArchiveDocument.scientificArchiveDocumentDetails.mediaType' |translate}}</div>
                    <div class="value">{{ details.mediaType | translateLang | async }}</div>
                </div>
            </div>
            <div class="section fixed-grid">
                <div class="item-container">
                    <div class="label">{{ 'iaa.scientificArchiveDocument.scientificArchiveDocumentDetails.folderLongId' |translate }}</div>
                    <div class="value">
                        <a class="custom-link" role="navigation" tabindex="0"
                            (click)="goToFolder(details.folderEntityId);"
                            (keydown.enter)="goToFolder(details.folderEntityId);">{{
                            details.folderLongId }}</a>
                    </div>
                </div>
                <div class="item-container">
                    <div class="label">{{ 'iaa.scientificArchiveDocument.scientificArchiveDocumentDetails.folderContainerNumber' |translate }}</div>
                    <div class="value">{{ details.folderContainerNumber }}</div>
                </div>
                <div class="item-container">
                    <div class="label">{{ 'iaa.scientificArchiveDocument.scientificArchiveDocumentDetails.totalPages' |translate }}</div>
                    <div class="value">{{ details.totalPages }}</div>
                </div>
            </div>
            <div class="section-keyword">
                <app-scientific-archive-document-keywords
                    [keywords]="details.keywords"  [currentLanguage]="currentLanguage"></app-scientific-archive-document-keywords>
            </div>
            <div class="section fixed-grid">
                <div class="item-container">
                    <div class="label">{{ 'iaa.scientificArchiveDocument.scientificArchiveDocumentDetails.author' |translate}}</div>
                    <div class="value">{{ details.author }}</div>
                </div>
                <div class="item-container">
                    <div class="label">{{ 'iaa.scientificArchiveDocument.scientificArchiveDocumentDetails.language' |translate }}</div>
                    <div class="value">{{ details.language }}</div>
                </div>
            </div>
            <div class="section fixed-grid">
                <div class="item-container">
                    <div class="label">{{ 'iaa.scientificArchiveDocument.scientificArchiveDocumentDetails.boxId' |translate  }}</div>
                    <div class="value">{{ details.boxId }}</div>
                </div>
                <div class="item-container">
                    <div class="label">{{ 'iaa.scientificArchiveDocument.scientificArchiveDocumentDetails.lastUpdated' |translate }}</div>
                    <div class="value">{{ details.depositionDate }}</div>
                </div>
            </div>
            <div style="flex-grow: 1;"></div>
        </div>
        <div class="image-preview" *ngIf="images">
            <app-archive-image-gallery [images]="images" [thumbnails]="thumbnails || []" [showZoom]="true" [showActivePage]="true"
              [currentLanguage]="currentLanguage"  class="gallery"></app-archive-image-gallery>
        </div>
    </div>
</app-card-scroller>